import config from '../config';

//
// A partner customer that never set a logo carries neither id, and the logo
// route refuses a malformed one the banning way: no id, no url, no request.
//
const partnerLogoUrl = (backUrl, cuid, logoId, wideLogoId) => (
  (backUrl && cuid && (logoId || wideLogoId))
    ? `${backUrl}/${config.town.back.logos.get + cuid}/${logoId || wideLogoId}`
    : undefined
);

export default partnerLogoUrl;
